import { FC, useState } from 'react';

import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const APARTMENT_NUMBER_NAME = 'apartment_number';

interface Props {
  name?: string;
}

const InputApartmentNumber: FC<Props> = ({ name = APARTMENT_NUMBER_NAME }) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();
  const [focused, setFocused] = useState(false);

  return (
    <FormField
      control={control}
      name={name}
      render={({
        field: { onBlur, onChange, ...field },
        fieldState: { error },
      }) => (
        <FormItem>
          <FormControl>
            <Input
              label={i18n.t('Nr lokalu')}
              error={error?.message}
              success={!focused && !error && !!field.value}
              autoComplete="address-line3"
              onFocus={() => setFocused(true)}
              onBlur={() => {
                setFocused(false);
                onBlur();
              }}
              onChange={(e) => {
                onChange(e);
                if (error) trigger(name);
              }}
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default InputApartmentNumber;
